import Cookies from 'universal-cookie';
import root from 'window-or-global';

import localStorageWrapper from './LocalStorageWrapper';
import FetchHelper from './FetchHelper';
import { API_URL, GET_INTERNATIONAL_CITIES_API, DUMMY_EMAIL_PATTERNS, ROUTES } from '../constants';
import { ROLE_KEYWORD_MAP_FOR_SEO } from '../assets/roleKeywords';


export const loadExternalJS =  (src, callback) => {
	let s = root.document && root.document.createElement('script');
	s.src = src;
	s.async = true;
	s.onreadystatechange = s.onload = function() {
		let state = s.readyState;
		if (!callback.done && (!state || /loaded|complete/.test(state))) {
			callback.done = true;
			callback();
		}
	};
  root.document && root.document.getElementsByTagName('head')[0].appendChild(s);
};

export const getParamFromUrl = ( param ) => {
  let params = {};
  if (typeof root !== 'undefined') {
    params = (root.location && getParams(root.location.search)) || {};
  }
  return (params[param]) ? params[param] : null;
};

export const getParams = (query) => {
  if (!query) {
    return { };
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, { });
};

export const capitalizeFirstLetter = (string) =>  {
  try {
    return string[0].toUpperCase() + string.slice(1);
  } catch (error) {
    return string;
  }

};

export const getOptionListFromArray = (list) => {
  let optionList =[];
  for (let optionValue of list) {
    optionList.push({ id: optionValue, value: optionValue });
  }
  return optionList;
};

export const sanitizeRole = (role) => {
  try {
    return role.replace(/\//g, '').replace(/-/g, '').replace(/ /g, '').toLowerCase();
  } catch (e) {
    return '';
  }
};

export const sanitizeRoleWithHyphen = (role) => {
  try {
    role.replace(/ \//g, '-').replace(/\/ /g, '-').replace(/\//g, '-').replace(/ /g, '-').toLowerCase();
  } catch (e) {
    return '';
  }
};

export const formatStringForDisplay = string => {
  string = hyphenToSpace(string);
  return ucwords(string, true);
};

export const ucwords = (string, join=false, separator=' ') => {
  let stringArray = string.split(' ');
  for (let index in stringArray) {
    if (stringArray.hasOwnProperty(index)) {
      let value = stringArray[index];
      stringArray[index] = capitalizeFirstLetter(value);
    }
  }

  if (join) {
    stringArray = stringArray.join(separator);
  }

  return stringArray;
};

export const hyphenToSpace = (role) => {
  if (role) {
    return role.replace(/-/g, ' ');
  } else {
    return role;
  }
};

export const spaceToHyphen = (text) => {
  if (text) {
    return text.replace(/ /g, '-');
  } else {
    return text;
  }
};

export const replaceUrlParameter = (param, newval, search) => {
  let regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
  let query = search.replace(regex, '$1').replace(/&$/, '');

  return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
};

export const updateInterstitialConfig = (page) => {
  if (JobSnow.isInterstialAdEnabled) {
    root.dispatchEvent(new CustomEvent('START_INTAD'));
  }
};

export const copyObject = (referencedObject) => JSON.parse(JSON.stringify(referencedObject));

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 *
 * https://gist.github.com/Yimiprod/7ee176597fef230d1451
 */
export const difference = (object, base) => {
  // function changes(object, base) {
  //   return _.transform(object, function(result, value, key) {
  //     if (!_.isEqual(value, base[key])) {
  //       result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
  //     }
  //   });
  // }

  // return changes(object, base);
  return {};
};

export const isCityEmpty = cityname => (('' === cityname) || ('undefined' === typeof cityname) || ('www' === cityname));

export const getInternationalCities = () => {
  let cities = {};
  let citiesFromLocalStorage = {};
  const key = 'getAllCities?type=international';
  if (localStorageWrapper.hasKey(key)) {
    citiesFromLocalStorage = JSON.parse(localStorageWrapper.getItem(key));
  }

  if (getObjectLength(citiesFromLocalStorage) > 0) {
    cities = citiesFromLocalStorage;
  } else if (root.location) {
    let fetchHelper = new FetchHelper();
    let params = {
      url: root.location.protocol + '//' + API_URL + GET_INTERNATIONAL_CITIES_API
    };
    let response = fetchHelper.request('GET', params);
    response.then((apiResponse) => {
      let response = (apiResponse.data) ? apiResponse.data : {};
      if (response.success && (response.json.length > 0)) {
        cities = JSON.stringify(response.json);
        localStorageWrapper.setItem(key, cities);
      }
    });
  }

  return cities;
};

export const isInternationalCity = cityName => {
  let cities = getInternationalCities();
  let isAbroadCity = false;

  for (let i = 0; i < cities.length; i++) {
    if (sanitizeRole(cities[i].value).toLowerCase() === sanitizeRole(cityName).toLowerCase()) {
      isAbroadCity = true;
      break;
    }
  }
  return isAbroadCity;
};

export const getObjectLength = object => Object.keys(object).length;

export const getProtocol = () => (root.location && root.location.protocol + '//');

export const getDomain = () => (root.location && root.location.hostname);

export const getPathname = () => (root.location && root.location.pathname);

export const isDebugMode = () => {
  let cookies = new Cookies();
  return cookies.get('isDebugMode');
};

export const getFormattedInterviewDate = (date, separator, isInterview=true, forApi=false, isDateTime=false) => {
  let finalDateTime = '';
  let today = date ? date : new Date();

  let dd = today.getDate();
  dd = isInterview ? dd + 1 : dd;

  let mm = today.getMonth() + 1; // January is 0
  let yyyy = today.getFullYear();
  let h = today.getHours();
  let m = today.getMinutes();
  let s = today.getSeconds();

  const checkTime = (i) => {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  };

  dd = checkTime(dd);
  mm = checkTime(mm);
  h = checkTime(h);
  m = checkTime(m);
  s = checkTime(s);

  separator = separator ? separator : '/';
  finalDateTime = forApi ? `${yyyy}${separator}${mm}${separator}${dd}` : `${dd}${separator}${mm}${separator}${yyyy}`;

  if (isDateTime) {
    const time = h + ":" + m + ":" + s;
    finalDateTime = finalDateTime + ' ' + time;
  }

  return finalDateTime;
}

export const overflowHidden = (add) => {
  if (typeof root.document === 'undefined') {return;}
  let body = root.document && root.document.body;
  if (add) {
    body.classList.add('overflowHidden');
  } else {
    body.classList.remove('overflowHidden');
  }
};

export const initJsVars = (preloadedState) => {
  root.QAP_VERSION = '4.0.1';

  root.JobSnow = {
    zone: '',
    isMobile: true,
    requestType: '',
    legacyRequestType: '',
    jobType: '',
    gaTrackId: '',
    keywords: '',
    lang: "en",
    langName: "english",
    gaTrackingUrl: "",
    seoUrlCombinations: "",
    roles: "",
    localities: "",
    email: '',
    mobile: '',
    userId: '',
    utmcampaign: '',
    utmmedium: '',
    utmsource: '',
    isCommonHeader: '',
    rolesSubRoles: '',
    assetUrl: '',
    rolesDBUser: '',
    // isInterstialAdEnabled: false,
    // isFlyingCarpetAdEnabled: false,
    route: 'home'
  };

  if (preloadedState && preloadedState.globalContainer && preloadedState.globalContainer.QDFPVERSION) {
    root.QDFPVERSION = preloadedState.globalContainer.QDFPVERSION;
  } else {

  }

  if (preloadedState && preloadedState.globalContainer && preloadedState.globalContainer.jobsContext) {
    const jobsContext = preloadedState.globalContainer.jobsContext;

    let updatedValue = {
      city: jobsContext.city,
      cityId: jobsContext.cityId,
      role: jobsContext.role,
      isloggedIn: jobsContext.isloggedIn,
      isInterstialAdEnabled: jobsContext.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: jobsContext.isFlyingCarpetAdEnabled,
      upgradeAdAbRand: jobsContext.upgradeAdAbRand

    };

    if (jobsContext.route) {
      updatedValue.route = jobsContext.route;
    }

    root.JobSnow = Object.assign(root.JobSnow, updatedValue);
  } else if (preloadedState && preloadedState.jobs) {
    let updatedValue = {
      city: preloadedState.jobs.context.city,
      cityId: preloadedState.jobs.context.cityId,
      role: preloadedState.jobs.context.role,
      isloggedIn: preloadedState.jobs.user.loggedIn,
      isInterstialAdEnabled: preloadedState.jobs.context.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: preloadedState.jobs.context.isFlyingCarpetAdEnabled
    };

    if (preloadedState.jobs.window.locationPathname) {
      updatedValue.route = getQdfpRoute(preloadedState.jobs.window.locationPathname);
    }

    root.JobSnow = Object.assign(root.JobSnow, updatedValue);
  }
};


export const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    const context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

export const isDummyEmail = (emailId) => {
  let isDummyEmailId = false;
  if (emailId) {
    for (let index in DUMMY_EMAIL_PATTERNS) {
      if (DUMMY_EMAIL_PATTERNS.hasOwnProperty(index)) {
        let pattern = DUMMY_EMAIL_PATTERNS[index];
        if (emailId.match(pattern)) {
          isDummyEmailId = true;
        }
      }
    }
  }

  return isDummyEmailId;
};

export const timeAgo = (date) => {
  date = new Date(date);
  const seconds = Math.floor((new Date() - date) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " year ago";
    }
    return Math.floor(interval) + " years ago";
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " month ago";
    }
    return Math.floor(interval) + " months ago";
  }

  interval = seconds / 86400;
  if (interval > 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " day ago";
    }
    return Math.floor(interval) + " days ago";
  }

  interval = seconds / 3600;
  if (interval >= 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " hour ago";
    }
    return Math.floor(interval) + " hours ago";
  }

  interval = seconds / 60;
  if (interval >= 1) {
    if (Math.floor(interval) === 1) {
      return Math.floor(interval) + " minute ago";
    }
    return Math.floor(interval) + " minutes ago";
  }

  return Math.floor(seconds) + " seconds ago";
};

// function to get timezone offset of the current user from the browser
// and update the utc date according to current timezone
export const getTimezoneOffsetDate = (date) => {
  return new Date(new Date(date).getTime() - new Date().getTimezoneOffset() * 60000);
};

export const getApplySourceFromPageType = pageType => {
  let source = null;

  switch(pageType) {
    case 'SNB':
      source = 'SNB';
      break;
    case 'VAP':
      source = 'VAP';
      break;
  }

  return source;
};

export const updateJobSnow = (values) => {
  if (root.JobSnow && typeof root.JobSnow !== 'undefined') {
    root.JobSnow = Object.assign(root.JobSnow, values);
  }
};

export const getQdfpRoute = (locationPathname) => {
  if (locationPathname.indexOf('W0QQAdIdZ') > -1) {
    return ROUTES['VAP'];
  } else if (locationPathname.indexOf('zwqxj') > -1) {
    return ROUTES['SNB'];
  }
};

export const getUserIdFromCookies = () => {
  let cookies = new Cookies();
  return cookies.get('__u');
};

export const isLoggedIn = () => {
  return !!getUserIdFromCookies();
};

export const parsePrimaryRole = role => {
  let primaryRole = '';

  if (('undefined' !== typeof role) && null != role && (role.indexOf('/') !== -1)) {
    let roleParams = role.split('/');
    primaryRole = roleParams[0].trim();
  }
  return primaryRole;
};

export const parseSecondaryRole = role => {
  let secondaryRole = '';

  if (('undefined' !== typeof role) && null != role && (role.indexOf('/') !== -1)) {
    let roleParams = role.split('/');
    secondaryRole = roleParams[1].trim();
  }

  return secondaryRole;
};

export const getKeywordsForRoleSEO = (role, seoType) => {
  let keywords = '';

  if (ROLE_KEYWORD_MAP_FOR_SEO.hasOwnProperty(role) && ROLE_KEYWORD_MAP_FOR_SEO[role].hasOwnProperty(seoType)) {
    let keywordsArray = ROLE_KEYWORD_MAP_FOR_SEO[role][seoType].split(', ');

    if ('title' === seoType) {
      //removing keywords from array which exactly match the role
      let roleIndex = keywordsArray.indexOf(role);
      if (roleIndex !== -1) {
        keywordsArray.splice(roleIndex, 1);
      }
    }


    keywords = keywordsArray.join(', ');
  }

  return keywords;
};
 
export function adConverionEvent() {
  if (typeof dataLayer != 'undefined') {
    dataLayer.push(arguments);
  }
}


// WEBPACK FOOTER //
// ../q-jobs/src/utils/index.js